import { Button, Divider, Text } from '@cencosud-cencommerce/paris-uikit';

import { URL_ROUTES } from '@/constants';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

const NoProductsOnStock = () => (
  <>
    <div className="co-w-full  co-flex co-flex-col tablet:co-flex-row tablet:co-px-1.5 tablet:co-py-3 co-gap-2 co-justify-between tablet:co-items-center">
      <div>
        <Text variant="subtitle3" weight={600}>
          Estos productos se eliminarán de tu carro
        </Text>
        <Text className="co-hidden tablet:co-block" variant="body2">
          Puedes guardarlos para después, buscar en otra comuna o explorar
          productos similares.
        </Text>
        <Text className="tablet:co-hidden" variant="body2">
          Busca en otra comuna o explora opciones similares.
        </Text>
      </div>
      <div>
        <Button onClick={() => redirectToUrl(URL_ROUTES.CART)}>
          Explorar productos
        </Button>
      </div>
    </div>
    <Divider className="co-hidden tablet:co-block" />
  </>
);

export default NoProductsOnStock;
